import { useState } from "preact/hooks";
import { deviceName } from "../state/config.js";
import { manualJoin, submitCode } from "../state/join.js";

/**
 * Beitritts-Screen: EINEN Code eingeben (+ optional Gerätename) → das Gerät holt sich seinen
 * Token (join.php entscheidet byd/betreiber anhand des Codes). Kein Slug, keine Rolle-Auswahl.
 * Nach Erfolg sauber auf „/" laden. `manual` = aus dem Login erneut geöffnet (Event wechseln).
 */
export function JoinView({ manual }: { manual?: boolean }) {
  const [code, setCode] = useState("");
  const [name, setName] = useState(deviceName.value);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const go = async () => {
    if (!code.trim()) { setErr("Bitte den Code eingeben."); return; }
    setErr("");
    setBusy(true);
    try {
      await submitCode(code, name);
      location.href = "/"; // Token (+ ggf. Venue) gesetzt → sauberer Neustart in die App
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  };

  return (
    <div class="login">
      <div class="login-title">Anmelden</div>
      <div class="join-box">
        <p class="muted">
          Code eingeben (bekommst du vom Veranstalter). Der Code verbindet dieses Gerät mit der
          Veranstaltung bzw. dem Betrieb.
        </p>
        <label class="fld">
          Code
          <input
            value={code}
            onInput={(e) => setCode(e.currentTarget.value)}
            placeholder="rowefo96"
            autocapitalize="none"
            autocorrect="off"
            spellcheck={false}
            onKeyDown={(e) => { if (e.key === "Enter") void go(); }}
          />
        </label>
        <label class="fld">
          Gerätename <span class="muted">(optional, z. B. „Kassa 1")</span>
          <input
            value={name}
            onInput={(e) => setName(e.currentTarget.value)}
            placeholder="Kassa 1"
          />
        </label>
        {err && <div class="login-error">{err}</div>}
        <button class="btn-primary" disabled={busy} onClick={() => void go()}>
          {busy ? "…" : "Beitreten"}
        </button>
        {manual && (
          <button class="btn-secondary" onClick={() => (manualJoin.value = false)}>
            Abbrechen
          </button>
        )}
      </div>
    </div>
  );
}
